import { ErrorMessage, type ErrorMessageProps } from 'formik';
import type { TOptions } from 'i18next';
import { useTranslation } from 'react-i18next';

import type { YupI18nError } from '@tmh-website/services/validation.service';

const FormErrorMessage = ({ name }: ErrorMessageProps) => {
  const { t } = useTranslation();

  return (
    <ErrorMessage name={name}>
      {error => {
        let errorMessage: string;

        // @ts-expect-error even tho Yup says that `error` is a string, it can be anything. In our case a YupI18nError.
        const i18nError = error as YupI18nError;
        if (typeof error === 'string') {
          // Support for custom error
          errorMessage = error;
        } else {
          const options: TOptions = { params: i18nError.params };
          const err = t(`validation:${i18nError.key}`, options) ?? t(`global:${i18nError.key}`, options);

          if (typeof err !== 'string') {
            // We weren't able to translate the error. Return a generic one.
            errorMessage = t('validation:mixed.default');
          } else {
            errorMessage = err;
          }
        }

        const document = new DOMParser().parseFromString(errorMessage, 'text/html');
        return document.documentElement.textContent || errorMessage;
      }}
    </ErrorMessage>
  );
};

export default FormErrorMessage;
